// extracted by mini-css-extract-plugin
export default {"root":"style_root__2Knfr","text":"style_text__-Ly79","input":"style_input__RAF+K","button":"style_button__IQyO2"};